import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: { flex: 1, position: 'relative' },
  map: { width: '100%', height: 480 },
});
